const commonValidationCheck = {
    /*******************************************************************************************/
    // オブジェクト判定
    // obj: オブジェクトか検査する対象のもの
    /*******************************************************************************************/
    isObj: function (obj) {
        return Object.prototype.toString.call(obj) === "[object Object]"
    },
    /*******************************************************************************************/
    // 配列判定
    // arr: 配列か検査する対象のもの
    /*******************************************************************************************/
    isArray: function (arr) {
        return Array.isArray(arr);
    },
    /*******************************************************************************************/
    // 文字列判定
    // str: 文字列か検査する対象のもの
    //これも恐らくデータ型としては文字列であるが、内容は数値でもstring型として認識されるのではじけてない
    /*******************************************************************************************/
    isString: function (str) {
        return typeof (str) === "string" ? true : false;
    },
    /*******************************************************************************************/
    // 1以上の整数判定
    // num: 1以上の整数か検査する対象のもの
    // 数値である && 整数である && 1以上である
    /*******************************************************************************************/
    isNumber: function (num) {
        const targetNum = Number(num);
        return ((!(isNaN(targetNum))) && (Number.isInteger(targetNum)) && (targetNum >= 1));
    }
}

export default commonValidationCheck